import { connect } from 'react-redux';
import SinglePromotions from '../components/SinglePromotionsComponent';
import {
    fetchSinglePromotionIfNeeded, fetchPromotionWinners,
    fetchUserAnswer, saveAnswer, resetPromotionData,
} from '../actions/SinglePromotionsActions';
import { setProfileModalState } from '../../profile/actions/ProfileActions';


const mapStateToProps = (state) => ({
    singlePromotionData: state.promotions.singlePromotions.singlePromotionData,
    promotionWinnersData: state.promotions.singlePromotions.promotionWinnersData,
    userAnswer: state.promotions.singlePromotions.userAnswer,
    isFetching: state.promotions.singlePromotions.isFetching,
    lastSlug: state.promotions.singlePromotions.lastSlug,
    isLogged: state.profile.jwt || false,
    registrationComplete: !!state.profile.user.registrationComplete,
    canSeeWinners: !!state.profile.jwt,
    notFound: state.promotions.singlePromotions.notFound,
    isPro: !!state.profile.user.isPro,
});

const mapDispatchToProps = (dispatch) => ({
    fetchSinglePromotionIfNeeded: (slug) => {
        dispatch(fetchSinglePromotionIfNeeded(slug));
    },
    fetchPromotionWinners: (idPromotion) => {
        dispatch(fetchPromotionWinners(idPromotion));
    },
    fetchUserAnswer: (userId, idPromotion) => {
        dispatch(fetchUserAnswer(userId, idPromotion));
    },
    saveAnswer: (idUserPromotion, idPromotion, answer, callback) => {
        dispatch(saveAnswer(idUserPromotion, idPromotion, answer, callback));
    },
    setProfileModalState: (open) => {
        dispatch(setProfileModalState(open));
    },
    resetPromotionData: () => {
        dispatch(resetPromotionData());
    },
});

const SinglePromotionsContainers = connect(
    mapStateToProps,
    mapDispatchToProps,
)(SinglePromotions);

export default SinglePromotionsContainers;
